import React, { FC, ReactNode, useMemo, useRef, useState } from 'react';
import { useDelayedHover } from './AvailablePricesSelector/useDelayedHover';
import { Tooltip } from '../components/Tooltip';
import classNames from 'classnames';

type Props = {
    /**
     * The text displayed within the tooltip.
     */
    readonly text?: string;

    readonly size?: Size;

    /**
     * Optional class names.
     */
    readonly className?: string;

    readonly children?: ReactNode;
};

type Size = 'small' | 'medium' | 'large' | 'extra-large';

export const HelpTooltip: FC<Props> = ({ text, size: sizeProp, className, children }) => {
    const [visible, setVisible] = useState(false);

    const size = useMemo(() => {
        if (sizeProp) {
            return sizeProp;
        }

        if (text) {
            return determineSize(text.length);
        }

        return 'medium';
    }, [text, sizeProp]);

    const infoIconRef = useRef<HTMLElement>(null);

    const { onMouseEnter, onMouseLeave } = useDelayedHover({
        onHover: setVisible,
        delayActive: false
    });

    return (
        <div className={classNames('tooltip', className)}>
            <i className="material-icon" ref={infoIconRef} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                info
            </i>
            <Tooltip target={infoIconRef} visible={visible} placement="top" size={size}>
                {text ? <div dangerouslySetInnerHTML={{ __html: text }} /> : children}
            </Tooltip>
        </div>
    );
};

function determineSize(textLength: number): Size {
    if (textLength < 50) {
        return 'small';
    } else if (textLength < 100) {
        return 'medium';
    } else if (textLength < 150) {
        return 'large';
    } else {
        return 'extra-large';
    }
}
